import { render } from "./ProductErrorDialog.vue?vue&type=template&id=dde64d4c"
import script from "./ProductErrorDialog.vue?vue&type=script&lang=js"
export * from "./ProductErrorDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__